import {
  PanelContainer,
  useIsDesktop,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {Flex, View} from 'native-base';
import React from 'react';

import SecurityMask from 'components/SecurityMask';
import MirroredGradient from 'components/SecurityMask/MirroredGradient';

import {GatedModulePropTypes} from '..';

const GatedSignInInfoModule: React.FC<GatedModulePropTypes> = ({isLoading}) => {
  const isDesktop = useIsDesktop();

  return (
    <PanelContainer
      isLoading={isLoading}
      panelTitle="Sign-In Information"
      icon="lock"
      testID="sign-in">
      <Flex
        mt={2}
        mb={isDesktop ? '36px' : '16px'}
        flexDirection={isDesktop ? 'row' : 'column'}
        width="100%">
        <View
          flexDirection="column"
          minW="50%"
          paddingRight={isDesktop ? 6 : 0}>
          <View marginBottom={isDesktop ? 0 : 4} flexDirection="row">
            <View width="100%" mr={6}>
              <SecurityMask title="Username" showAsterisk />
            </View>
            <View
              borderRightColor={
                isDesktop ? 'rgba(112, 119, 132, .2)' : undefined
              }
              borderRightWidth={isDesktop ? 1 : undefined}
            />
          </View>
        </View>
        <View paddingLeft={isDesktop ? 6 : undefined} />
        <View flexGrow={1} flexShrink={1}>
          <SecurityMask title="Email Address" showAsterisk />
        </View>
      </Flex>
    </PanelContainer>
  );
};

export default GatedSignInInfoModule;
